import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pdfmagnificationoptions"
    }}>{`PdfMagnificationOptions`}</h1>
    <p>{`PDF export magnification options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEFAULT_VALUE`}</strong>{` = 1147563124`}</p>
      <p parentName="blockquote">{`Uses default magnification.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ACTUAL_SIZE`}</strong>{` = 2053206906`}</p>
      <p parentName="blockquote">{`Uses the actual size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_PAGE`}</strong>{` = 2053534832`}</p>
      <p parentName="blockquote">{`Uses the fit page magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_WIDTH`}</strong>{` = 1212437335`}</p>
      <p parentName="blockquote">{`Uses the fit width magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_HEIGHT`}</strong>{` = 1212437352`}</p>
      <p parentName="blockquote">{`Uses the fit height magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_VISIBLE`}</strong>{` = 1212437334`}</p>
      <p parentName="blockquote">{`Uses the fit visible magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWENTY_FIVE_PERCENT`}</strong>{` = 2053534822`}</p>
      <p parentName="blockquote">{`Uses 25 percent magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIFTY_PERCENT`}</strong>{` = 2053531248`}</p>
      <p parentName="blockquote">{`Uses 50 percent magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEVENTY_FIVE_PERCENT`}</strong>{` = 2053534566`}</p>
      <p parentName="blockquote">{`Uses 75 percent magnification option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_HUNDRED_PERCENT`}</strong>{` = 2053533544`}</p>
      <p parentName="blockquote">{`Uses 100 percent magnification option.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      